import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { clearNotificationStatus, setNotificationStatus } from '../../../../../redux/notifier/notifierReducer';

function ImagesGeneratingStatusController({ generationLabel }) {
  const dispatch = useDispatch();

  const isImagesGenerating = useSelector((state) => state.demoRecreate.isGenerating);

  useEffect(() => {
    if (isImagesGenerating) {
      dispatch(setNotificationStatus(generationLabel ?? 'generationInProgress'));
    } else {
      dispatch(clearNotificationStatus());
    }

    return () => {
      dispatch(clearNotificationStatus());
    };
  }, [isImagesGenerating, generationLabel, dispatch]);

  return null;
}

export default ImagesGeneratingStatusController;
